var _rect, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 22,
    viewBox: "0 0 63 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 22,
    rx: 4,
    fill: "#46CD80"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5469_6504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.58325 11.0007C8.58325 11.0007 10.9166 6.33398 14.9999 6.33398C19.0833 6.33398 21.4166 11.0007 21.4166 11.0007C21.4166 11.0007 19.0833 15.6673 14.9999 15.6673C10.9166 15.6673 8.58325 11.0007 8.58325 11.0007Z",
    stroke: "#F7F7F7",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 12.75C15.9665 12.75 16.75 11.9665 16.75 11C16.75 10.0335 15.9665 9.25 15 9.25C14.0335 9.25 13.25 10.0335 13.25 11C13.25 11.9665 14.0335 12.75 15 12.75Z",
    stroke: "#F7F7F7",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7073 6.54L30.2873 13.788L32.9033 6.54H34.0913L30.9833 15H29.6033L26.5073 6.54H27.7073ZM35.0024 6.48C35.0024 6.28 35.0704 6.12 35.2064 6C35.3424 5.872 35.5224 5.808 35.7464 5.808C35.9704 5.808 36.1504 5.872 36.2864 6C36.4224 6.12 36.4904 6.28 36.4904 6.48C36.4904 6.68 36.4224 6.844 36.2864 6.972C36.1504 7.092 35.9704 7.152 35.7464 7.152C35.5224 7.152 35.3424 7.092 35.2064 6.972C35.0704 6.844 35.0024 6.68 35.0024 6.48ZM36.2864 8.412V15H35.1944V8.412H36.2864ZM44.102 11.34C44.102 11.572 44.086 11.772 44.054 11.94H38.786C38.81 12.692 39.022 13.256 39.422 13.632C39.83 14.008 40.326 14.196 40.91 14.196C41.438 14.196 41.878 14.064 42.23 13.8C42.59 13.528 42.81 13.168 42.89 12.72H44.054C43.974 13.176 43.794 13.584 43.514 13.944C43.242 14.304 42.886 14.584 42.446 14.784C42.006 14.984 41.51 15.084 40.958 15.084C40.326 15.084 39.766 14.948 39.278 14.676C38.79 14.404 38.406 14.016 38.126 13.512C37.854 13 37.718 12.4 37.718 11.712C37.718 11.024 37.854 10.424 38.126 9.912C38.406 9.4 38.79 9.008 39.278 8.736C39.766 8.464 40.326 8.328 40.958 8.328C41.598 8.328 42.154 8.464 42.626 8.736C43.106 9.008 43.47 9.372 43.718 9.828C43.974 10.284 44.102 10.788 44.102 11.34ZM42.998 11.412C43.022 10.924 42.942 10.516 42.758 10.188C42.574 9.86 42.322 9.616 42.002 9.456C41.682 9.296 41.334 9.216 40.958 9.216C40.358 9.216 39.854 9.404 39.446 9.78C39.038 10.148 38.818 10.692 38.786 11.412H42.998ZM54.5783 8.412L52.6823 15H51.5063L49.6943 9.636L47.8703 15H46.6823L44.8103 8.412H45.9143L47.3183 13.956L49.1423 8.412H50.2823L52.1183 13.944L53.5343 8.412H54.5783Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5469_6504"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(8 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.2ebbee1cd99cf14263051336bd3c878f.svg";
export { ForwardRef as ReactComponent };